import React from 'react';

export class MDCButtonIcon extends React.Component{
   constructor(props){
       super(props)
   }

   rawMarkup(body){
    return { __html: body };
   }

   render(){
       var cls=this.props.cls;
       if(!cls) cls='mdc-button-icon mdc-ripple-surface';
       else cls='mdc-button-icon mdc-ripple-surface ' + cls;
       if(this.props.active) cls+=' active';
       return(
          <div className={cls} onClick={this.props.onButtonClick} data-id={this.props.id} data-index={this.props.index} data-anchor={this.props.anchor}>
              <i className="material-icons">{this.props.icon}</i>
              <span dangerouslySetInnerHTML={this.rawMarkup(this.props.label)}></span>
          </div>
       );
   }
}

export class MDCBottomBar extends React.Component{
   constructor(props){
       super(props)
   }

   show(){
       this.bottomBar.classList.add('active');
   }

   hide(){
       this.bottomBar.classList.remove('active');
   }

   render(){
       var containerCss='mdc-bottom-bar-container';
       if(this.props.active) containerCss+=' active';
       var cls=this.props.cls;
       if(!cls) cls='mdc-bottom-bar';
       else cls='mdc-bottom-bar ' + cls;
       
       return(
          <div className={containerCss}>
              <div className={cls} ref={(ref) => this.bottomBar = ref}>
                 {this.props.children}
              </div>
          </div>
       );
   }
}

export class MDCFabButton extends React.Component{
   constructor(props){
       super(props)
   }

   rawMarkup(body){
    return { __html: body };
   }

   show(){
      this.element.classList.add('show-fab-button');
      setTimeout(()=>{
          this.element.classList.remove('hide-fab-button');
          this.element.classList.remove('hidden');
        },250);
   }

   hide(){
      this.element.classList.remove('show-fab-button'); 
      this.element.classList.add('hide-fab-button');
   }

   render(){
       var cls=this.props.cls;
       if(!cls) cls='mdc-fab material-icons';
       else cls='mdc-fab material-icons ' + cls;
       if(this.props.hide) cls+=' hidden';
       return(
         <button className={cls}
            aria-label={this.props.label}
            data-mdc-auto-init="MDCRipple" 
            onClick={this.props.onClick}
            ref={(ref) => this.element = ref}
            >
           <span className="mdc-fab__icon" dangerouslySetInnerHTML={this.rawMarkup(this.props.icon)}></span>
         </button>
       );
   }
}

export class MDCSnackBar extends React.Component{
    constructor(props){
        super(props)
    }

    componentDidMount() {
        this.snackbar=mdc.snackbar.MDCSnackbar.attachTo(this.element);
    }

    componentWillUnmount(){
        this.snackbar.destroy();
    }

    onClick=(event)=>{
        if(this.props.onAction) this.props.onAction();
    }

    show(message){
        var dataObj={};
        if(typeof message==='string'){
            dataObj.message=message;
        }else{
            dataObj=message;
        }
        if (!dataObj.actionText && this.props.actionText) dataObj.actionText = this.props.actionText;
        if (!dataObj.actionHandler && this.props.actionHandler) dataObj.actionHandler = this.props.actionHandler;
        if(!dataObj.timeout && this.props.timeout) dataObj.timeout=this.props.timeout;
        if (!dataObj.multiline && this.props.multiline) dataObj.multiline = this.props.multiline;
        if (!dataObj.actionOnBottom && this.props.actionOnBottom) dataObj.actionOnBottom = this.props.actionOnBottom;
        this.snackbar.show(dataObj);
    }


    render(){
        var cls=this.props.cls;
        if(!cls) cls='mdc-snackbar mdc-snackbar--align-start';
        else cls='mdc-snackbar mdc-snackbar--align-start ' + cls;
        var buttonCss='mdc-snackbar__action-button';
        if(this.props.disableButton) buttonCss +=' hide';
        return(
           <div className={cls} 
                aria-live="assertive"
                aria-atomic="true"
                aria-hidden="true" 
                ref={(ref) => this.element = ref}>
             <div className="mdc-snackbar__text"></div>
             <div className="mdc-snackbar__action-wrapper">
               <button type="button" className={buttonCss}></button>
             </div>
           </div>
        );
    }
}

export class MDCFileUpload extends React.Component {
    constructor(props) {
        super(props)
        this.postUrl = this.props.postUrl;
        this.authorization = this.props.authorization;
        this.tag = this.props.tag;
        this.activeUploadJob = false;
        this.currentFile = null;
        this.headers = null;
        this.state = { files: [] };
        //NOTE: for multiple file uploads(enabled by default), the component will upload files sequentially
    }

    componentDidMount() {
        this._isMounted = true;
        if (!this.props.singleFileUpload) {
            this.input.setAttribute('multiple', 'multiple');
        }
        this.xhr = new XMLHttpRequest();
        this.xhr.upload.addEventListener("progress", this.onXhrUploadProgress.bind(this));
        this.xhr.upload.addEventListener("error", this.onXhrUploadError.bind(this));
    }

    componentWillUnmount() {
        this._isMounted = false;
        var xhr = this.xhr;
        xhr.upload.removeEventListener("progress", this.onXhrUploadProgress.bind(this));
        xhr.upload.removeEventListener("error", this.onXhrUploadError.bind(this));
        this.xhr = null;
    }

    setComponentState(obj) {
        if (this._isMounted) this.setState(obj);
    }

    onDragOver(event) {
        event.preventDefault();
        this.element.classList.add('drag-over');
    }

    onDragLeave(event) {
        event.preventDefault();
        this.element.classList.remove('drag-over');
    }

    onDrop(event) {
        event.preventDefault();
        this.element.classList.remove('drag-over');
        var files = event.dataTransfer.files;
        if (this.props.onBeforeUpload) this.props.onBeforeUpload(files);
        else this.setFilesArray(files);
    }

    onFileChange(event) {
        var files = event.target.files;
        if (this.props.onBeforeUpload) this.props.onBeforeUpload(files);
        else this.setFilesArray(files);
    }

    onFileProgressClear(file) {
        var newFiles = this.arrayDeleteById(this.state.files, file.id);
        //this.setState({ files: newFiles });
        this.setComponentState({ files: newFiles });
    }

    onUploadError(obj) {
        if (this.props.onUploadError) this.props.onUploadError(obj);
    }

    onUploadComplete(obj) {
        if (this.props.onUploadComplete) this.props.onUploadComplete(obj);
    }

    onUploadProgressComplete() {
        if (this.props.onUploadProgressComplete) this.props.onUploadProgressComplete();
    }

    onXhrUploadProgress(event) {
        var file = this.currentFile;
        var progress = ((event.loaded) / event.total);
        file.progress = progress;
        this.updateState(file);
        if (progress === 1) this.onUploadProgressComplete();
    }

    onXhrUploadComplete(response) {
        this.activeUploadJob = false;
        var file = this.currentFile;
        file.complete = true;
        file.progress = 100;
        file.queued = false;
        this.updateState(file);
        this.currentFile = null;
        this.processFiles();
        if(this.props.onUploadCompleted){
            this.props.onUploadCompleted(file);
        }
        this.onUploadComplete(response);
    }

    onXhrUploadError(obj) {
        this.activeUploadJob = false;
        var file = this.currentFile;
        if (!file) return;
        file.progress = 0;
        file.error = true;
        file.queued = false;
        this.updateState(file);
        this.currentFile = null;
        this.processFiles();
        if (!obj) this.onUploadError(file);
        else this.onUploadError(obj);
    }

    setFilesArray(files) {
        var arr = [];
        var length = files.length;
        //iterate the file blobs
        for (var i = 0; i < length; i++) {
            //create the file entity object
            var file = files[i]; //file blob
            var total = parseFloat(file.size / 1000).toFixed(2);
            var f = {
                id: file.name,
                size: total.toString() + ' KB',
                total: file.size,
                progress: 0,
                type: file.type,
                complete: false,
                error: false,
                queued: true,
                blob: file /** assign the file blob itself to the blob property of the entity object **/
            };
            //push the file entity objects into arr
            arr.push(f);
        }
        //add entities array to state
        this.addFilesToState(arr);
        //upload the new files
        this.processFiles();
    }

    addFilesToState(files) {
        var currentFiles = this.state.files;
        var newFiles = currentFiles.concat(files);
        this.state.files = newFiles;
        if (this._isMounted) this.setState(this.state.files);
    }

    updateState(file) {
        var clone = this.state.files.slice(0);
        var index = this.arrayIndexById(clone, file.id);
        clone[index] = file;
        this.state.files = clone;
        if (this._isMounted) this.setState(this.state.files);
    }

    processFiles() {
        if (!this.activeUploadJob) {
            var file = this.popFileQueue();
            if (file) {
                this.currentFile = file;
                this.activeQueueJob = true;
                this.uploadFileXhr(file);
            } else {
                this.activeUploadJob = false;
            }
        }
    }

    popFileQueue() {
        var files = this.state.files;
        var length = files.length;
        var file = null;
        for (var i = 0; i < length; i++) {
            if (files[i].queued) {
                file = files[i];
                file.queued = false;
                break;
            }
        }
        return file;
    }

    uploadFileXhr(file) {
        var responseObj;
        this.currentFile = file;
        var postUrl = this.postUrl;
        var formData = new FormData();
        //upload the blob, not the entity object abstraction
        formData.append('file', file.blob);
        var xhr = this.xhr;
        xhr.open("POST", postUrl);
        xhr.overrideMimeType('text/plain; charset=x-user-defined-binary');
        if (this.authorization) xhr.setRequestHeader('Authorization', this.authorization);
        if (this.tag) xhr.setRequestHeader('Tag', this.tag);
        if (this.headers) {
            this.headers.forEach((obj) => {
                xhr.setRequestHeader(obj.key, obj.value);
            })
            this.headers = null;
        }
        //SEND
        try {
            xhr.send(formData);
        } catch (ex) {
        }

        xhr.onreadystatechange = () => {
            if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
                responseObj = JSON.parse(xhr.response);
                this.onXhrUploadComplete(responseObj);
            } else if (xhr.status !== 200 && xhr.status !== 0) {
                if (xhr.response && xhr.response !== '') {
                    try {
                        responseObj = JSON.parse(xhr.response);
                    } catch (ex) {
                        responseObj = { status: xhr.status, statusCode: xhr.status };
                    }
                    this.onXhrUploadError(responseObj);
                } else {
                    this.onXhrUploadError({ status: xhr.status, statusCode: xhr.status })
                }
            }
        };
    }

    resume(files) {
        this.setFilesArray(files);
    }

    ///helpers
    arrayDeleteById(arr, id) {
        var clone = arr.slice(0);
        var index = this.arrayIndexById(clone, id);
        if (index > -1) {
            clone.splice(index, 1);
        }
        return clone;
    }

    arrayUpdateElement(arr, element) {
        var clone = arr.slice(0);
        var index = this.arrayIndexById(clone, id);
        clone[index] = element;
        return clone;
    }

    arrayFindById(arr, id) {
        var length = arr.length;
        var result = null;
        for (var i = 0; i < length; i++) {
            if (arr[i]['id'] === id) {
                result = arr[i];
                break;
            }
        }
        return result;
    }

    arrayIndexById(arr, id) {
        var index = -1;
        var len = arr.length;
        for (var i = 0; i < len; i++) {
            if (arr[i]['id'] === id) {
                index = i;
                break;
            }
        }
        return index;
    }

    reset() {
        this.input.value = '';
    }

    render() {
        var id = this.props.id;
        if (!id) id = 'mdcInputFile';
        var cls = this.props.cls;
        if (!this.props.cls) cls = 'mdc-file-upload';
        else cls = 'mdc-file-upload ' + this.props.cls;
        var files = this.state.files;
        var progressNodes = files.map((file) => {
            return (
                <MDCFileProgress file={file} key={file.id} onFileProgressClear={this.onFileProgressClear.bind(this)} />
            );
        });
        var accept = "*";
        if (this.props.accept) accept = this.props.accept;
        return (
            <div className={cls} ref={(ref) => this.element = ref}>
                <div className="drop-zone" onDragOver={this.onDragOver.bind(this)} onDragLeave={this.onDragLeave.bind(this)} onDrop={this.onDrop.bind(this)}>
                    <label className="button ink" htmlFor={id}>Upload</label>
                    <i className="material-icons icon">file_upload</i>
                    <span className="drop-label">Drop files here...</span>
                    <input type="file" id={id} ref={(ref) => this.input = ref} onChange={this.onFileChange.bind(this)} accept={accept} />
                </div>
                <div className="progress">
                    {progressNodes}
                </div>
            </div>
        );
    }
}

export class MDCFileProgress extends React.Component {
    constructor(props) {
        super(props)
    }

    onFileProgressClear(event) {
        if (this.props.onFileProgressClear) this.props.onFileProgressClear(this.props.file);
    }

    render() {
        var cls = this.props.cls;
        var file = this.props.file;
        var complete = file.complete;
        var error = file.error;
        if (!cls) cls = 'mdc-file-progress';
        else cls = 'mdc-file-progress ' + cls;
        var progress = Math.round(100 * (parseFloat(file.progress)));
        var doneCss = 'material-icons done';
        var statusCss = 'status-name';
        var progressInfoCss = 'progress-info';
        var closeCss = 'material-icons close';
        var statusIcon = '';
        if (complete) {
            doneCss += ' complete';
            statusCss += ' complete';
            progressInfoCss += ' complete';
            statusIcon = 'done';
        } else if (error) {
            doneCss += ' error';
            statusCss += ' error';
            progressInfoCss += ' error';
            closeCss += ' error';
            statusIcon = 'error';
        }
        return (
            <div className={cls}>
                <div className="row">
                    <i className={doneCss}>{statusIcon}</i>
                    <span className={statusCss}>{file.id}</span>
                    <div className={progressInfoCss}>
                        <span className="name">{file.id}</span>
                        <div className="progress-stats">
                            <span className="size">{file.size}</span>
                            <span>{progress}% uploaded</span>
                        </div>
                    </div>
                    <i className={closeCss} onClick={this.onFileProgressClear.bind(this)}>clear</i>
                </div>
                <MDCProgressBar progress={file.progress} />
            </div>
        );
    }
}

export class MDCProgressBar extends React.Component{
   constructor(props){
       super(props)
   }

   componentDidMount() {
       this.progressBar=mdc.linearProgress.MDCLinearProgress.attachTo(this.element);
       if(this.props.indeterminate) this.progressBar.determinate=false;
       else if(this.props.progress) this.progressBar.progress=parseFloat(this.props.progress);
   }

   componentWillUnmount(){
       this.progressBar.destroy();
   }

   componentDidUpdate() {
       if(this.props.progress) this.progressBar.progress=parseFloat(this.props.progress);
   }

   set progress(val){
       this.progressBar.progress=val;
   }

   complete(){
     this.progressBar.progress=1;
   }

   render(){
       var cls=this.props.cls;
       if(!cls) cls='mdc-linear-progress';
       else cls='mdc-linear-progress ' + cls;

       return(
         <div role="progressbar" className="mdc-linear-progress" ref={(ref) => this.element = ref}>
           <div className="mdc-linear-progress__buffering-dots"></div>
           <div className="mdc-linear-progress__buffer"></div>
           <div className="mdc-linear-progress__bar mdc-linear-progress__primary-bar">
             <span className="mdc-linear-progress__bar-inner"></span>
           </div>
           <div className="mdc-linear-progress__bar mdc-linear-progress__secondary-bar">
             <span className="mdc-linear-progress__bar-inner"></span>
           </div>
         </div>
       );
   }
}

export class MDCTabBarScroller extends React.Component{
    constructor(props){
        super(props)
    }

    componentDidMount() {
        this.tabs=mdc.tabs.MDCTabBarScroller.attachTo(this.element);
        this.tabs.tabBar.listen('MDCTabBar:change', this.onTabChange.bind(this));
    }

    componentWillUnmount(){
        this.tabs.tabBar.unlisten('MDCTabBar:change', this.onTabChange.bind(this));
        this.tabs.destroy();
    }

    onTabChange(event){
        var index=event.detail.activeTabIndex;
        if(this.props.onTabChange) this.props.onTabChange(index);
    }

    get activeTab(){
        return this.tabs.tabBar.activeTab;
    }

    set activeTab(tab){
        this.tabs.tabBar.activeTab=tab;
    }

    get activeTabIndex(){
        return this.tabs.tabBar.activeTabIndex;
    }

    set activeTabIndex(index){
        this.tabs.tabBar.activeTabIndex=index;
    }

    render(){
        var id=this.props.id;
        if(!id) id='mdc-tab-bar-scroller';
        var cls=this.props.cls;
        if(!cls) cls='mdc-tab-bar-scroller';
        else cls='mdc-tab-bar-scroller ' + cls;
        return(
            <div id={id} className={cls} ref={(ref) => this.element = ref}>
                <div className="mdc-tab-bar-scroller__indicator mdc-tab-bar-scroller__indicator--back">
                  <a className="mdc-tab-bar-scroller__indicator__inner material-icons" aria-label="scroll back button">
                     navigate_before
                  </a>
                </div>
                <div className="mdc-tab-bar-scroller__scroll-frame">
                  <nav className="mdc-tab-bar mdc-tab-bar-scroller__scroll-frame__tabs">
                    {this.props.children}
                    <span className="mdc-tab-bar__indicator"></span>  
                  </nav>
                </div>
                <div className="mdc-tab-bar-scroller__indicator mdc-tab-bar-scroller__indicator--forward">
                  <a className="mdc-tab-bar-scroller__indicator__inner material-icons" aria-label="scroll forward button">
                    navigate_next
                  </a>
                </div>
            </div>
        );
    }
}

export class MDCIconTextTabBar extends React.Component{
    constructor(props){
        super(props)
    }

    componentDidMount() {
        this.tabs=mdc.tabs.MDCTabBar.attachTo(this.element);
        this.tabs.tabBar.listen('MDCTabBar:change', this.onTabChange.bind(this));
    }

    componentWillUnmount(){
        this.tabs.tabBar.unlisten('MDCTabBar:change', this.onTabChange.bind(this));
        this.tabs.destroy();
    }

    onTabBarChange(event){
        var index=event.detail.activeTabIndex;
        if(this.props.onTabChange) this.props.onTabChange(index);
    }

    get activeTab(){
        return this.tabs.tabBar.activeTab;
    }

    set activeTab(tab){
        this.tabs.tabBar.activeTab=tab;
    }

    get activeTabIndex(){
        return this.tabs.tabBar.activeTabIndex;
    }

    set activeTabIndex(index){
        this.tabs.tabBar.activeTabIndex=index;
    }

    render(){
        var id=this.props.id;
        if(!id) id='mdc-icon-text-tabs';
        var cls=this.props.cls;
        if(!cls) cls='mdc-tab-bar mdc-tab-bar--icons-with-text';
        else cls='mdc-tab-bar mdc-tab-bar--icons-with-text ' + cls;
        return(
           <nav id={id} class={cls} ref={(ref) => this.element = ref}>
             {this.props.children}
             <span class="mdc-tab-bar__indicator"></span>
           </nav>
        );
    }
}

export class MDCIconTabBar extends React.Component{
    constructor(props){
        super(props)
    }

    componentDidMount() {
        this.tabs=mdc.tabs.MDCTabBar.attachTo(this.element);
        this.tabs.tabBar.listen('MDCTabBar:change', this.onTabChange.bind(this));
    }

    componentWillUnmount(){
        this.tabs.tabBar.unlisten('MDCTabBar:change', this.onTabChange.bind(this));
        this.tabs.destroy();
    }

    onTabBarChange(event){
        var index=event.detail.activeTabIndex;
        if(this.props.onTabChange) this.props.onTabChange(index);
    }

    get activeTab(){
        return this.tabs.tabBar.activeTab;
    }

    set activeTab(tab){
        this.tabs.tabBar.activeTab=tab;
    }

    get activeTabIndex(){
        return this.tabs.tabBar.activeTabIndex;
    }

    set activeTabIndex(index){
        this.tabs.tabBar.activeTabIndex=index;
    }

    render(){
        var id=this.props.id;
        if(!id) id='mdc-icon-tabs';
        var cls=this.props.cls;
        if(!cls) cls='mdc-tab-bar mdc-tab-bar--icon-tab-bar';
        else cls='mdc-tab-bar mdc-tab-bar--icon-tab-bar ' + cls;
        return(
           <nav id={id} class={cls} ref={(ref) => this.element = ref}>
             {this.props.children}
             <span class="mdc-tab-bar__indicator"></span>
           </nav>
        );
    }
}

export class MDCTabBar extends React.Component{
    constructor(props){
        super(props)
    }

    componentDidMount() {
        this.tabs=mdc.tabs.MDCTabBar.attachTo(this.element);
        this.tabs.tabBar.listen('MDCTabBar:change', this.onTabChange.bind(this));
    }

    componentWillUnmount(){
        this.tabs.tabBar.unlisten('MDCTabBar:change', this.onTabChange.bind(this));
        this.tabs.destroy();
    }

    onTabBarChange(event){
        var index=event.detail.activeTabIndex;
        if(this.props.onTabChange) this.props.onTabChange(index);
    }

    get activeTab(){
        return this.tabs.tabBar.activeTab;
    }

    set activeTab(tab){
        this.tabs.tabBar.activeTab=tab;
    }

    get activeTabIndex(){
        return this.tabs.tabBar.activeTabIndex;
    }

    set activeTabIndex(index){
        this.tabs.tabBar.activeTabIndex=index;
    }

    render(){
        var id=this.props.id;
        if(!id) id='mdc-tabs';
        var cls=this.props.cls;
        if(!cls) cls='mdc-tab-bar';
        else cls='mdc-tab-bar ' + cls;
        return(
           <nav id={id} class={cls} ref={(ref) => this.element = ref}>
             {this.props.children}
             <span class="mdc-tab-bar__indicator"></span>
           </nav>
        );
    }
}

export class MDCFormSwitch extends React.Component{
   constructor(props){
       super(props)
   }

   onCheckedChange(event){
     if(this.props.onCheckedChange) this.props.onCheckedChange(event);
   }

   render(){
       var id=this.props.id;
       if(!id) id='switch';
       var cls=this.props.fieldCls;
       if(!cls) cls='mdc-form-field';
       else cls='mdc-form-field ' + cls;
       return(
        <div className={cls}>
           <MDCSwitch id={this.props.id} name={this.props.name} value={this.props.value} checked={this.props.checked} cls={this.props.cls} onCheckedChange={this.onCheckedChange.bind(this)} />
           <label htmlFor={id}>{this.props.label}</label>
        </div>
       );
   }
}

class MDCSwitch extends React.Component{
    constructor(props){
        super(props)
    }

    componentDidMount() {
        if(this.props.checked) this.checked=true;
        if(this.props.disabled)  this.switch.disabled=true;
    }

    componentDidUpdate() {
        if(this.props.checked) this.checked=true;
        else this.checked=false;
        if(this.props.disabled)  this.switch.disabled=true;
        else this.switch.disabled=false;
    }

    get checked(){
        return this.switch.checked;
    }

    set checked(val){
        this.switch.checked=val;
    }

    onClick({target}){
        var checked=this.switch.checked;
        if(this.props.onCheckedChange) this.props.onCheckedChange(checked);
    }

    render(){
        var id=this.props.id;
        if(!id) id='switch';
        var name=this.props.name;
        if(!name) name=id;
        var cls=this.props.cls;
        if(!cls) cls='mdc-switch';
        else cls='mdc-switch ' + cls;
        var checked=this.props.checked;
        return(
            <div className={cls}>
              <input type="checkbox" id={id} name={name} className="mdc-switch__native-control" value={this.props.value} 
              onClick={this.onClick.bind(this)} ref={(ref) => this.switch = ref} />
              <div className="mdc-switch__background">
                <div className="mdc-switch__knob"></div>
              </div>
            </div>
        );
    }
}

export class MDCSlider extends React.Component{
   constructor(props){
       super(props)
   }

   componentDidMount() {
       this.slider=mdc.slider.MDCSlider.attachTo(this.element);
       if(this.props.onChange) this.slider.listen('MDCSlider:change', this.props.onChange);
   }

   componentWillUnmount(){
       if(this.props.onChange) this.slider.unlisten('MDCSlider:change', this.props.onChange);
       this.slider.destroy();
   }

   get value(){
       return this.slider.value;
   }

   set value(val){
       this.slider.value=val;
   }

   get step(){
       return this.slider.step;
   }

   set step(val){
       this.slider.step=val;
   }

   render(){
      var id=this.props.id;
      if(!id) id='slider';
      var cls=this.props.cls;
      if(!cls) cls='mdc-slider mdc-slider--discrete';
      else cls='mdc-slider mdc-slider--discrete ' + cls;

      var minValue=this.props.minValue;
      if(!minValue) minValue=0;
      var maxValue=this.props.maxValue;
      if(!maxValue) maxValue=100;
      var value=this.props.value;
      if(!value) value=0;

      return(
        <div className={cls} tabIndex="0" role="slider" 
             aria-valuemin={minValue} aria-valuemax={maxValue} aria-valuenow={value}
             aria-label="Select Value" id={id} ref={(ref) => this.element = ref}>
          <div className="mdc-slider__track-container">
            <div className="mdc-slider__track"></div>
          </div>
          <div className="mdc-slider__thumb-container">
            <div className="mdc-slider__pin">
              <span className="mdc-slider__pin-value-marker"></span>
            </div>
            <svg className="mdc-slider__thumb" width="21" height="21">
              <circle cx="10.5" cy="10.5" r="7.875"></circle>
            </svg>
            <div className="mdc-slider__focus-ring"></div>
          </div>
        </div>
      );
   }
}

export class MDCFormRadio extends React.Component{
   constructor(props){
       super(props)
   }

   onCheckedChange(event){
     if(this.props.onCheckedChange) this.props.onCheckedChange(event);
   }

   addCss(cls){
      this.div.classList.add(cls);
   }

   removeCss(cls){
      this.div.classList.remove(cls);
   }

   render(){
       var id=this.props.id;
       if(!id) id='radio';
       var cls=this.props.fieldCls;
       if(!cls) cls='mdc-form-field';
       else cls='mdc-form-field ' + cls;
       return(
        <div className={cls} ref={(ref) => this.div = ref}>
           <MDCRadio id={this.props.id} name={this.props.name} value={this.props.value} checked={this.props.checked} cls={this.props.cls} index={this.props.index} onCheckedChange={this.onCheckedChange.bind(this)} />
           <label htmlFor={id}>{this.props.label}</label>
        </div>
       );
   }
}

export class MDCRadio extends React.Component{
    constructor(props){
        super(props)
    }

    onChange(event){
        if(this.props.onCheckedChange) this.props.onCheckedChange(event);
    }

    componentDidMount() {
        this.radio=mdc.radio.MDCRadio.attachTo(this.element);
        //if(this.props.onCheckedChange) this.radio.listen('MDCRadio:change', this.props.onCheckedChange);
        if(this.props.checked) this.checked=true;
        if(this.props.disabled)  this.radio.disabled=true;
    }

    componentWillUnmount(){
        this.radio.destroy();
    }

    componentDidUpdate() {
        if(this.props.checked) this.checked=true;
        else this.checked=false;
        if(this.props.disabled && this.radio)  this.radio.disabled=true;
        else if(this.radio) this.radio.disabled=false;
    }

    get value(){
        return this.radio.value;
    }

    set value(val){
        this.radio.value=val;
    }

    get checked(){
        return this.radio.checked;
    }

    set checked(val){
        this.radio.checked=val;
    }

    render(){
        var id=this.props.id;
        if(!id) id='radio';
        var name=this.props.name;
        if(!name) name=id;
        var cls=this.props.cls;
        if(!cls) cls='mdc-radio';
        else cls='mdc-radio ' + cls;
        var value=this.props.value;
        return(
            <div className={cls} ref={(ref) => this.element = ref}>
              <input className="mdc-radio__native-control" type="radio" id={id} name={name} onChange={this.onChange.bind(this)} data-index={this.props.index} value={value}  />
              <div className="mdc-radio__background">
                <div className="mdc-radio__outer-circle"></div>
                <div className="mdc-radio__inner-circle"></div>
              </div>
            </div>
        );
    }
}

export class MDCPopOver extends React.Component{
    constructor(props){
        super(props)
    }

    componentDidMount() {
        if(!this.props.disableInit){
            this.menu=mdc.menu.MDCSimpleMenu.attachTo(this.element);
        }
    }

    show(){
        this.menu.show();
    }

    hide() {
        this.menu.hide();
    }

    get open(){
        return this.menu.open;
    }

    render(){
        var id=this.props.id;
        if(!id) id='mdc-popover';
        var cls=this.props.cls;
        if(!cls) cls='mdc-simple-menu';
        else cls='mdc-simple-menu ' + cls;
        return(
           <div className={cls} tabIndex="-1" id={id} ref={(ref) => this.element = ref}>
             <div className="mdc-simple-menu__items mdc-list" role="menu" aria-hidden="true">
              {this.props.children}
             </div>
           </div>
        );
    }
}

export class MDCAnchorMenu extends React.Component{
    constructor(props){
        super(props)
    }

    componentDidMount() {
        setTimeout(()=>{
            var click=this.click;
            var menuElement = this.element.querySelector('.mdc-simple-menu');
            this.menu=mdc.menu.MDCSimpleMenu.attachTo(menuElement);
            this.menu.listen('MDCSimpleMenu:selected', this.props.onMenuSelected);
            if(this.props.onMenuClose){
                this.menu.listen('MDCSimpleMenu:cancel', this.props.onMenuSelected);
            }
            this.anchor= this.element.querySelector('[data-anchor]');
            this.anchor.addEventListener(click,this.onAnchorClick.bind(this));
            this.anchor.addEventListener('mousedown',(event)=>event.preventDefault());
        },250);
    }

    componentWillUnmount(){
        var click=this.click;
        if(this.props.onMenuClose){
            this.menu.unlisten('MDCSimpleMenu:cancel', this.props.onMenuSelected);
        }
        this.menu.unlisten('MDCSimpleMenu:selected', this.props.onMenuSelected);
        this.anchor.removeEventListener(click,this.onAnchorClick.bind(this));
        this.anchor.removeEventListener('mousedown',(event)=>event.preventDefault());
        this.menu.destroy();
    }

    get click(){
        return ('ontouchend' in document) ? 'touchend' : 'click';
    }

    onAnchorClick(event){
        (this.menu.open) ? this.menu.hide() : this.menu.show();
    }

    render(){
        var cls=this.props.cls;
        if(!cls) cls='mdc-menu-anchor';
        else cls='mdc-menu-anchor ' + cls;
        return(
            <div className={cls} ref={(ref) => this.element = ref}>
              {this.props.children}
            </div>
        );
    }
}

export class MDCMenu extends React.Component{
    constructor(props){
        super(props)
    }

    componentDidMount() {
        if(!this.props.disableInit){
            this.menu=mdc.menu.MDCMenu.attachTo(this.element);
            if(this.props.onMenuSelected) this.menu.listen('MDCMenu:selected', this.props.onMenuSelected);
        }
    }

    componentWillUnmount(){
        if(!this.props.disableInit){
            if(this.props.onMenuSelected) this.menu.unlisten('MDCMenu:selected', this.props.onMenuSelected);
            this.menu.destroy();
        }
    }

    render(){
        var id=this.props.id;
        if(!id) id='mdc-menu';
        var cls=this.props.cls;
        if(!cls) cls='mdc-simple-menu';
        else cls='mdc-simple-menu ' + cls;
        return(
           <div className={cls} tabIndex="-1" ref={(ref) => this.element = ref}>
             <ul className="mdc-simple-menu__items mdc-list" role="menu" aria-hidden="true">
              {this.props.children}
             </ul>
           </div>
        );
    }
}

export class MDCFormCheckbox extends React.Component{
   constructor(props){
       super(props)
   }

   onCheckedChange(event){
     if(this.props.onCheckedChange) this.props.onCheckedChange(event);
   }

   addCss(cls){
      this.div.classList.add(cls);
   }

   removeCss(cls){
      this.div.classList.remove(cls);
   }

    get checked() {
        return this.checkbox.checked;
    }

    set checked(val) {
        this.checkbox.checked = val;
    }

   render(){
       var id=this.props.id;
       if(!id) id='checkbox';
       var cls=this.props.fieldCls;
       if(!cls) cls='mdc-form-field';
       else cls='mdc-form-field ' + cls;
       return(
        <div className={cls} ref={(ref) => this.div = ref}>
           <MDCCheckbox id={this.props.id} name={this.props.name} cls={this.props.cls} value={this.props.value} checked={this.props.checked} disabled={this.props.disabled} 
           onCheckedChange={this.onCheckedChange.bind(this)} ref={(ref) => this.checkbox = ref} />
           <label htmlFor={id}>{this.props.label}</label>
        </div>
       );
   }
}

export class MDCCheckbox extends React.Component{
   constructor(props){
       super(props)
   }

   componentDidMount() {
       this.checkbox=mdc.checkbox.MDCCheckbox.attachTo(this.element);
       if(this.props.checked) this.checked=true;
       if(this.props.disabled)  this.checkbox.disabled=true;
   }

   componentWillUnmount(){
       this.checkbox.destroy();
   }

   onChange(event){
      if(this.props.onCheckedChange) this.props.onCheckedChange(event);
   }

   componentDidUpdate() {
       if(this.props.checked) this.checked=true;
       else this.checked=false;
       if(this.props.disabled)  this.checkbox.disabled=true;
       else this.checkbox.disabled=false;
   }

   get checked(){
       return this.checkbox.checked;
   }

   set checked(val){
       this.checkbox.checked=val;
   }

   render(){
      var id=this.props.id;
      if(!id) id='checkbox';
      var name=this.props.name;
      if(!name) name=id;
      var cls=this.props.cls;
      if(!cls) cls='mdc-checkbox';
      else cls='mdc-checkbox ' + cls;
      var value=this.props.value;
      return(
        <div className={cls} ref={(ref) => this.element = ref}>
           <input type="checkbox" className="mdc-checkbox__native-control" 
                  id={id} 
                  name={name} 
                  value={value} 
                  onClick={this.onChange.bind(this)} 
            />
           <div className="mdc-checkbox__background">
             <svg className="mdc-checkbox__checkmark"
                  viewBox="0 0 24 24">
               <path className="mdc-checkbox__checkmark__path"
                     fill="none"
                     stroke="white"
                     d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
             </svg>
             <div className="mdc-checkbox__mixedmark"></div>
           </div>
         </div>
      );
   }
}

export class MDCSelect extends React.Component{
    constructor(props){
        super(props)
    }

    componentDidMount() {
        this.select=mdc.select.MDCSelect.attachTo(this.element);
        if(this.props.onSelectChange) this.select.listen('MDCSelect:change', this.props.onSelectChange);
        if(this.props.value) this.selectedValue=this.props.value;
    }

    componentWillUnmount(){
        if(this.props.onSelectChange) this.select.unlisten('MDCSelect:change', this.props.onSelectChange);
        this.select.destroy();
    }

    get selectedItem(){
        return this.select.selectedOptions[0];
    }

    get selectedIndex(){
        return this.select.selectedIndex;
    }

    get selectedValue(){
        return this.select.selectedOptions[0].dataset.value;
    }

    set selectedIndex(val){
        this.select.selectedIndex=val;
    }

    set selectedValue(val){
        var index=-1;
        var matchedIndex=-1;
        var li=this.ul.querySelectorAll('li');
        for(var i=0; i<li.length;i++){
            index+=1;
            if(li[i].dataset.value===val) matchedIndex=index;
        } 
        if(matchedIndex > -1) this.select.selectedIndex=matchedIndex;
    }

    render(){
        var id=this.props.id;
        if(!id) id='select-list';
        var cls=this.props.cls;
        if(!cls) cls='mdc-select';
        else cls='mdc-select ' + cls;
        return(
            <div className={cls} id={id} role="listbox" ref={(ref) => this.element = ref}>
              <div className="mdc-select__surface" tabIndex="0">
                {this.props.selected ? (
                    <div className="mdc-select__label mdc-select__label--float-above">{this.props.label}</div>
                ):(
                    <div className="mdc-select__label">{this.props.label}</div>
                )}
                <div className="mdc-select__selected-text"></div>
                <div className="mdc-select__bottom-line"></div>
              </div>
              <div className="mdc-simple-menu mdc-select__menu">
                <ul className="mdc-list mdc-simple-menu__items" ref={(ref) => this.ul = ref}>
                  {this.props.children}
                </ul>
              </div>
            </div>
        );
    }
}

export class MDCNativeSelect extends React.Component {
    constructor(props) {
        super(props)
    }

    onSelectChange = (event) => {
        var target = event.target;
        var value = target.value;
        var index = target.selectedIndex;
        var option = event.target.options[index];
        var text = option.innerText;
        if (this.props.onSelectChange) this.props.onSelectChange({ value: value, text: text, target: target })
    }


    get value() {
        return this.select.value;
    }

    set value(val) {
        this.select.value = val;
    }

    get selectedIndex() {
        return this.select.selectedIndex;
    }

    set selectedIndex(val) {
        this.select.selectedIndex = val;
    }

    render() {
        var name = this.props.name;
        if (!name) name = "select-name";
        var id = this.props.id;
        if (!id) id = 'select-id';
        
        return (
            <div>
                <div className="mdc-select-label">{this.props.label}</div>
                <div className="mdc-select">
                    <select name={name} id={id} className="mdc-select__surface" onChange={this.onSelectChange} defaultValue={this.props.value} ref={(ref) => this.select = ref}>
                        {this.props.children}
                    </select>
                    <div className="mdc-select__bottom-line"></div>
                </div>
            </div>
        );
    }
}

export class MDCTextArea extends React.Component{
    constructor(props){
        super(props)
    }

    componentDidMount() {
        this.input = new mdc.textField.MDCTextField(this.element);
        if(this.props.disabled) this.input.disabled=true;
        if(this.props.value) this.value=this.props.value;
        else this.value='';
    }

    componentWillUnmount(){
       this.input.destroy();
    }

    componentDidUpdate() {
        if(this.props.value) this.value=this.props.value;
        else this.value='';
        if(this.props.disabled) this.input.disabled=true;
        else this.input.disabled=false;
    }

    get value(){
        return this.input.value;
    }

    set value(val){
        this.input.value=val;
    }

    onKeyPress(event){
        if(this.props.onKeyEnter){
            var code = event.keyCode ? event.keyCode : event.which;
            if(code==13){
                var target=event.target;
                var value=target.value;
                this.props.onKeyEnter(value);
            }
        }
    }

    onChange(event){
        if(this.props.onChange) this.props.onChange(event);
    }

    onFocus(event){
        if(this.props.onFocus) this.props.onFocus(event);
    }

    onBlur(event){
        if(this.props.onBlur) this.props.onBlur(event); 
    }

    focus(){
        this.inputElement.focus();
    }

    blur(){
        this.inputElement.blur();
    }

    render(){
        var id=this.props.id;
        if(!id) id='text-area';
        var name=this.props.name;
        if(!name) name=id;
        var cls=this.props.cls;
        if(!cls) cls='mdc-text-field mdc-text-field--textarea';
        else cls='mdc-text-field mdc-text-field--textarea ' + cls;
        var rows=this.props.rows;
        if(!rows) rows='8';
        var cols=this.props.cols;
        if(!cols) cols='40';
        var value=this.props.value;
        if(!value) value='';
        return(
           <div className={cls} ref={(ref) => this.element = ref}>
             <textarea id={id} name={name} className="mdc-text-field__input" rows={rows} cols={cols} defaultValue={value} 
                ref={(ref) => this.inputElement = ref} 
                onFocus={this.onFocus.bind(this)} 
                onBlur={this.onBlur.bind(this)} 
                onChange={this.onChange.bind(this)} 
                onKeyPress={this.onKeyPress.bind(this)}>
             </textarea>
             <label htmlFor={id} className="mdc-text-field__label">{this.props.label}</label>
           </div>
        )
    }
}

export class MDCTextInput extends React.Component{
    constructor(props){
        super(props)
    }

    componentDidMount() {
        this.input = new mdc.textField.MDCTextField(this.element);
        if(this.props.disabled) this.input.disabled=true;
        if(this.props.value) this.value=this.props.value;
        else this.value='';
    }

    componentWillUnmount(){
       this.input.destroy();
    }

    componentDidUpdate() {
        if(this.props.value) this.value=this.props.value;
        else this.value='';
        if(this.props.disabled) this.input.disabled=true;
        else this.input.disabled=false;
    }

    get value(){
        return this.input.value;
    }

    set value(val){
        this.input.value=val;
    }

    onKeyPress(event){
        if(this.props.onKeyEnter){
            var code = event.keyCode ? event.keyCode : event.which;
            if(code==13){
                this.props.onKeyEnter(event);
            }
        }
    }

    onChange(event){
        if(this.props.onChange) this.props.onChange(event);
    }

    onFocus(event){
        if(this.props.onFocus) this.props.onFocus(event);
    }

    onBlur(event){
        if(this.props.onBlur) this.props.onBlur(event); 
    }

    focus(){
        this.inputElement.focus();
    }

    blur(){
        this.inputElement.blur();
    }

    render(){
        var id=this.props.id;
        if(!id) id='text-field';
        var name=this.props.name;
        if(!name) name=id;
        var cls=this.props.cls;
        if(!cls) cls='mdc-text-field';
        else cls='mdc-text-field ' + cls;
        var type=this.props.type;
        if(!type) type='text';
        return(
            <div className={cls} ref={(ref) => this.element = ref}>
              <input type={type} id={id} name={name} className="mdc-text-field__input" defaultValue={this.props.value} placeholder={this.props.placeholder} 
                 ref={(ref) => this.inputElement = ref} 
                 onFocus={this.onFocus.bind(this)} 
                 onBlur={this.onBlur.bind(this)} 
                 onChange={this.onChange.bind(this)} 
                 onKeyPress={this.onKeyPress.bind(this)} 
               />
              <label className="mdc-text-field__label" htmlFor="my-text-field">{this.props.label}</label>
              <div className="mdc-text-field__bottom-line"></div>
            </div>
        )
    }
}

export class MDCIconTextInput extends React.Component{
    constructor(props){
        super(props)
    }

    componentDidMount() {
        this.input = new mdc.textField.MDCTextField(this.element);
        if(this.props.disabled) this.input.disabled=true;
        if(this.props.value) this.value=this.props.value;
        else this.value='';
    }

    componentWillUnmount(){
       this.input.destroy();
    }

    componentDidUpdate() {
        if(this.props.value) this.value=this.props.value;
        else this.value='';
        if(this.props.disabled) this.input.disabled=true;
        else this.input.disabled=false;
    }

    get value(){
        return this.input.value;
    }

    set value(val){
        this.input.value=val;
    }

    onKeyPress(event){
        if(this.props.onKeyEnter){
            var code = event.keyCode ? event.keyCode : event.which;
            if(code==13){
                var target=event.target;
                var value=target.value;
                this.props.onKeyEnter(value);
            }
        }
    }

    onChange(event){
        if(this.props.onChange) this.props.onChange(event);
    }

    onFocus(event){
        if(this.props.onFocus) this.props.onFocus(event);
    }

    onBlur(event){
        if(this.props.onBlur) this.props.onBlur(event); 
    }

    onIconClick(event){
        var input=this.inputElement;
        if(this.props.onIconClick){
            this.props.onIconClick(input.value);
        }
    }

    focus(){
        this.inputElement.focus();
    }

    blur(){
        this.inputElement.blur();
    }

    render(){
        var icon=this.props.icon;
        if(!icon) icon='edit';
        var id=this.props.id;
        var trailingIcon=this.props.trailingIcon;
        if(!id) id='text-field';
        var name=this.props.name;
        if(!name) name=id;
        var cls='mdc-text-field mdc-text-field--with-leading-icon';
        var propCls=this.props.cls;
        if(trailingIcon){
            cls='mdc-text-field mdc-text-field--with-trailing-icon';
            icon=trailingIcon;
        }
        if(propCls) cls+=' ' + propCls;
        var type=this.props.type;
        if(!type) type='text';
        
        return(
            <div className={cls} ref={(ref) => this.element = ref}>
              <input type={type} id={id} name={name} className="mdc-text-field__input" defaultValue={this.props.value} placeholder={this.props.placeholder} 
                    ref={(ref) => this.inputElement = ref} 
                    onFocus={this.onFocus.bind(this)} 
                    onBlur={this.onBlur.bind(this)} 
                    onChange={this.onChange.bind(this)} 
                    onKeyPress={this.onKeyPress.bind(this)} 
               />
              <label className="mdc-text-field__label" htmlFor="my-text-field">{this.props.label}</label>
              <i className="material-icons mdc-text-field__icon" tabIndex="0" onClick={this.onIconClick.bind(this)}>{icon}</i>
              <div className="mdc-text-field__bottom-line"></div>
            </div>
        )
    }
}

export class MDCDialog extends React.Component{
    constructor(props){
        super(props)
        this.cancel=this.props.cancel;
        if(!this.cancel) this.cancel='Cancel';
        this.accept=this.props.accept;
        if(!this.accept) this.accept='OK';
    }

    componentDidUpdate(){
        var props=this.props;
        if(props.validateAccept && props.disableAccept){
            this.disableAccept();
        }else if(props.validateAccept){
            this.enableAccept();
        }
        if (this.props.open && !this.dialog.open) {
            this.dialog.show();
        }
    }

    componentDidMount() {
        this.dialog = new mdc.dialog.MDCDialog(this.element);
        if(this.props.onDialogAccept) this.dialog.listen('MDCDialog:accept',this.props.onDialogAccept);
        if(this.props.onDialogCancel) this.dialog.listen('MDCDialog:cancel', this.props.onDialogCancel);
        var props = this.props;
        if (props.validateAccept && props.disableAccept) {
            this.disableAccept();
        } else if (props.validateAccept) {
            this.enableAccept();
        }
        if(this.props.open && !this.dialog.open){
            this.dialog.show();
        }
    }

    componentWillUnmount(){
       if(this.props.onDialogAccept) this.dialog.unlisten('MDCDialog:accept',this.props.onDialogAccept);
       if(this.props.onDialogCancel) this.dialog.unlisten('MDCDialog:cancel', this.props.onDialogCancel);
       this.dialog.destroy();
    }

    show(){
        if(!this.dialog.open) this.dialog.show();
    }

    disableAccept(){
        this.acceptButton.setAttribute('disabled',true);
    }

    enableAccept(){
        this.acceptButton.removeAttribute('disabled');
    }
    
    render(){
        var id=this.props.id;
        if(!id) id='mdc-dialog';
        var cls=this.props.cls;
        if(!cls) cls='mdc-dialog';
        else cls='mdc-dialog ' + cls;
        if(this.props.enableScrolling){
            cls+=' scrollable-dialog';
        }
        var bodyCss ="mdc-dialog__body";
        return(
            <aside className={cls} id={id} ref={(ref) => this.element = ref}  role="alertdialog" aria-labelledby="mdc-dialog-label" aria-describedby="mdc-dialog-description">
              <div className="mdc-dialog__surface">
                <header className="mdc-dialog__header">
                  <h2 className="mdc-dialog__header__title">
                    {this.props.header}
                  </h2>
                </header>
                <section className={bodyCss}>
                   {this.props.children}
                </section>
                <footer className="mdc-dialog__footer">
                  <button type="button" className="mdc-button mdc-dialog__footer__button mdc-dialog__footer__button--cancel">{this.cancel}</button>
                  <button type="button" className="mdc-button mdc-dialog__footer__button mdc-dialog__footer__button--accept" ref={(ref) => this.acceptButton = ref}>{this.accept}</button>
                </footer>
              </div>
              <div className="mdc-dialog__backdrop"></div>
            </aside>
        )
    }
}

export default {
    MDCButtonIcon,
    MDCBottomBar,
    MDCFabButton,
    MDCSnackBar,
    MDCFileUpload,
    MDCProgressBar,
    MDCTabBarScroller,
    MDCIconTextTabBar,
    MDCIconTabBar,
    MDCTabBar,
    MDCFormSwitch,
    MDCSlider,
    MDCFormRadio,
    MDCRadio,
    MDCPopOver,
    MDCAnchorMenu,
    MDCMenu,
    MDCFormCheckbox,
    MDCCheckbox,
    MDCSelect,
    MDCTextArea,
    MDCTextInput,
    MDCIconTextInput,
    MDCDialog,
    MDCNativeSelect
}